import { defineComponent as _defineComponent } from 'vue'
import { ref, withDefaults } from "vue";
import { useMediaQuery } from "@vueuse/core";
import { isAndroidDevice, isIOSdevice } from "@/utils/deviceType.util";

interface IProps {
  title?: string;
  desc?: string;
  boldDesc?: string;
  showStayInBrowser: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WeProposeApp',
  props: {
    title: { default: "Please continue in our mobile app" },
    desc: { default: "Our app has everything you will need to track your progress and reach your goals." },
    boldDesc: { default: "Scan QR-code and complete your onboarding in our mobile app" },
    showStayInBrowser: { type: Boolean, default: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { title: string, desc: string, boldDesc: string, showStayInBrowser: boolean }



const isMobile = useMediaQuery("(max-width: 680px)");
const currentEnv = ref<string>(process.env.VUE_APP_CURRENT_ENV);
const destinationLink = ref<string>(
  isIOSdevice.value
    ? "https://apps.apple.com/us/app/erf-clubhouse/id6526485959"
    : "https://play.google.com/store/apps/details?id=com.clubhouse.clubhouse_client"
);

const __returned__ = { props, isMobile, currentEnv, destinationLink, ref, withDefaults, useMediaQuery, isAndroidDevice, isIOSdevice }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})